import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../store/auth';
import { MID_TRANSFER_PROGRESS_STEPS } from '../../pages/Onboarding/CompanyTransfer/constants';

function ChooseOnboardingGuard({ element }: { element?: React.ReactNode | React.ComponentType }) {
  const { isAuthenticated, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const progressStep = user?.account?.progress_step;
    if (!progressStep) return;

    if (progressStep === 'concluded') {
      navigate('/dashboard');
      return;
    }

    // Mid-transfer: resume wizard instead of trapping the user on choose-onboarding.
    if ((MID_TRANSFER_PROGRESS_STEPS as readonly string[]).includes(progressStep)) {
      navigate('/company-transfer');
    }
  }, [isAuthenticated, user, navigate]);

  const progressStep = user?.account?.progress_step;
  if (
    progressStep === 'concluded' ||
    (progressStep && (MID_TRANSFER_PROGRESS_STEPS as readonly string[]).includes(progressStep))
  ) {
    return <></>;
  }

  return <>{element}</>;
}

export { ChooseOnboardingGuard };
